import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import '@/plugins/components';
import '@/plugins/scss';
import VendedorStorage from '@/plugins/VendedorStorage';

import '@/registerServiceWorker';

Vue.config.productionTip = false;

async function bootstrap() {
  // Restaura o vendedor da sessão anterior antes de montar a app, para que
  // recarregamentos/retomadas de aba (ex: ao voltar do WhatsApp) em
  // /detalhes ou /resumo não percam o vínculo e caiam no vendedor padrão.
  // Um "?simule=" explícito na URL sempre tem prioridade e é tratado em Dados.vue.
  const query = new URLSearchParams(window.location.search);
  const vendedorId = VendedorStorage.get();
  if (vendedorId && !query.has('simule')) {
    await store.dispatch.SET_VENDEDOR(vendedorId);
  }

  new Vue({
    router,
    store: store.original,
    vuetify,
    render: (h) => h(App),
  }).$mount('#app');
}

bootstrap();
